import Vue from "vue";

Vue.filter("findReorder", function(item)
{
    let isReorder = false;

    for (let i = 0; i < item.variationProperties.length; i++ )
    {
        if (item.variationProperties[i].id == 3)
        {
            for (let i2 = 0; i2 < item.variationProperties[i].properties.length; i2++)
            {
                if (item.variationProperties[i].properties[i2].id == 18)
                {
                    isReorder = true;
                }
            }
        }
    }
    return isReorder;
});
